import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path1/src/app/programs/ProgramsClient.tsx");
